import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "./App";
import { TrpcProvider } from "./TrpcProvider";
import { AuthProvider } from "./auth";
import "./index.css";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root element not found");

createRoot(rootElement).render(
  <StrictMode>
    <AuthProvider>
      <TrpcProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </TrpcProvider>
    </AuthProvider>
  </StrictMode>,
);
